Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.StyledCard = void 0;

var _styledComponents = _interopRequireDefault(require('styled-components'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _cachedTemplateObject;

function _templateObject() {
  if (_cachedTemplateObject) {
    return _cachedTemplateObject;
  }

  _cachedTemplateObject = _taggedTemplateLiteral([
    '\n  padding: ',
    '\n  background: ',
    '}\n  border: ',
    '\n  border-radius: ',
    '\n  box-shadow: ',
    '\n'
  ]);

  return _cachedTemplateObject;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var StyledCard = _styledComponents.default.div(
  _templateObject(),
  function (props) {
    return props.theme.card.padding;
  },
  function (props) {
    return props.theme.card.background.color;
  },
  function (props) {
    return ''
      .concat(props.theme.card.border.width, ' ')
      .concat(props.theme.card.border.style, ' ')
      .concat(props.theme.card.border.color);
  },
  function (props) {
    return props.theme.card.border.radius;
  },
  function (props) {
    return props.theme.card.boxShadow;
  }
);

exports.StyledCard = StyledCard;
